module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAAl0lEQVQYlX2P0Q2CQBBEpwvsAEJCiBWIQeuwFFu4L24f5EKp6w9nAJH53H0zsyvAzazWicysBlxABTjQHIFAs+yrPKiWhnaX2G7AVcLGEGO8/oCAj+N4k6SUUrkAL8BTSqUkTdPUAa4QQgF4jLFbP5MTgTvgIYRCkr4GM+t3N/cbMCsbhmF4LNXPQ3BvAN6nYNY8z5d/4AfkP4do37CMxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/images/icon_xia.png
// module id = l8nY
// module chunks = 2